import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
export const Envelope = loadable(() => import('./Envelope'), {});
export const Payment = loadable(() => import('./Payment'), {});
export const Product = loadable(() => import('./Product'), {});
export const UpdateStatusSetPaid = loadable(() => import('./UpdateStatusSetPaid'), {});
